export default "__VITE_ASSET__DtsTWgbB__"